import { createContext } from 'react'

export const SnackbarContext = createContext<{ snackMessage: string, setSnackMessage: any, type: string, setType: any }>({ snackMessage: '', setSnackMessage: () => {}, type: '', setType: () => {} })
